export const isObjectEmpty = (
  obj: Record<string, unknown>,
): obj is Record<string, never> => {
  return !Object.keys(obj).length;
};
